module.exports = __webpack_public_path__ + "img/Formosa 1867_1.bc0c2824.jpg";